import { memo } from 'react';
import { Checkbox } from '@library';
import useSearchParamFilterHelper from '../../hooks/useSearchParamFilterHelper';
import styles from './SimpleFilter.module.scss';

const SimpleFilter = ({
    field,
    label,
    testClass,
    isChecked,
}: {
    field: string;
    label: string;
    testClass: string;
    isChecked: boolean;
}) => {
    const { updateCurrentValues } = useSearchParamFilterHelper()('states');

    return (
        <div className={styles.filter}>
            <Checkbox
                data-test-class={testClass}
                checked={isChecked}
                onChange={e => {
                    updateCurrentValues(field, !e);
                }}
                value={label}
                truncate
            >
                {label}
            </Checkbox>
        </div>
    );
};

export default memo(SimpleFilter);
